export const SET_ROUTES = 'SET_ROUTES'
export const SET_NEXT_INDEX = 'SET_NEXT_INDEX'
export const CLEAR_WORKFLOW_DATA = 'CLEAR_WORKFLOW_DATA'
export const SET_FORCE_PASSWORD = 'SET_FORCE_PASSWORD'
export const SET_WORKFLOW_FLAGS = 'SET_WORKFLOW_FLAGS'
export const SET_IS_CUSTOM_WORKFLOW = 'SET_IS_CUSTOM_WORKFLOW'
export const SET_WORKFLOW_TYPE = 'SET_WORKFLOW_TYPE'
